/**
 * Strips combining diacritical marks (e.g. ą → a, ź → z) from a filename.
 */
export function sanitizeFilename(filename: string): string {
  return filename.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
